var _path, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDeleteMessage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M36 72C55.8823 72 72 55.8823 72 36C72 16.1177 55.8823 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72Z",
    fill: "#E4AA46"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1292_1846",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1292_1846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8 54L42 51.2L46.2 47L42 42.8L44.8 40L49 44.2L53.2 40L56 42.8L51.85 47L56 51.2L53.2 54L49 49.85L44.8 54ZM36 54C31.4 54 27.3917 52.475 23.975 49.425C20.5583 46.375 18.6 42.5667 18.1 38H22.2C22.6667 41.4667 24.2083 44.3333 26.825 46.6C29.4417 48.8667 32.5 50 36 50C36.3667 50 36.7083 49.9917 37.025 49.975C37.3417 49.9583 37.6667 49.9167 38 49.85V53.9C37.6667 53.9333 37.3417 53.9583 37.025 53.975C36.7083 53.9917 36.3667 54 36 54ZM18 32V20H22V24.7C23.7 22.5667 25.775 20.9167 28.225 19.75C30.675 18.5833 33.2667 18 36 18C41 18 45.25 19.75 48.75 23.25C52.25 26.75 54 31 54 36H50C50 32.1 48.6417 28.7917 45.925 26.075C43.2083 23.3583 39.9 22 36 22C33.7 22 31.55 22.5333 29.55 23.6C27.55 24.6667 25.8667 26.1333 24.5 28H30V32H18ZM38.7 41.5L34 36.8V26H38V35.2L40.8 38L38.7 41.5Z",
    fill: "#E4AA46"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteMessage);
export default __webpack_public_path__ + "static/media/icon-delete-message.29a3429a1fa225b362b88b16fd96a7c1.svg";
export { ForwardRef as ReactComponent };